module.exports = __webpack_public_path__ + "img/62.769a0a77.jpg";